const initialState = {
    data: [],
    dataview:[],
    attachdataview:[],
    attachdata:[],
  };
  
  const DneedViewReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, data: action.payload };
        case 'FETCH_VIEW_DATA_SUCCESS':
        return{ ...state, dataview: action.payload }
        case 'FETCH_ATTAC_VIEW_DATA_SUCCESS':
          return{ ...state, attachdataview: action.payload }
          case 'FETCH_VIEW_ATTACH_DATA_SUCCESS':
            return{ ...state, attachdata: action.payload }
      default:
        return state;
    }
  };
  
  export default DneedViewReducer;
  
  